import { withStyles } from '@material-ui/core';

import TypeLabel from './component';
import styles from './styles';

export default withStyles(styles)(TypeLabel);
